import React from 'react';
import './IconAction.scss';
import Tooltip from '@mui/material/Tooltip';

export const IconAction = ({IconComponent, onClick = () => {}, disabled, className, tooltip, tooltipPlacement = 'top', text, dataTestId}) => {
	let component;
	const ComponentWrapper = <div className="iconComponentWrapper" aria-label={tooltip}>
		{IconComponent}
		{text && <span className="icon-action-text">{text}</span>}
	</div>
	if (tooltip) {
		component = (
			<Tooltip title={tooltip} placement={tooltipPlacement}>
				{ComponentWrapper}
			</Tooltip>
		);
	} else {
		component = ComponentWrapper;
	}
	return (
		<div
			onClick={!disabled ? onClick : () => {}}
			className={`icon-action ${className} ${
				disabled ? 'disabled' : ''
			}`}
			data-testid={dataTestId}
		>
			{component}


		</div>
	);
}